
<div class="ionic ionic-example">
  <div class="bar bar-header bar-dark">
    <h1 class="title">{{'Address' | translate}}</h1>
  </div>
</div>
<div>
  <ion-row>
    <ion-col text-bold>{{'FirstName' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="address.firstname" placeholder="{{'FirstName' | translate}}" (modelDataOut)="address.firstname=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'LastName' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" placeholder="{{'LastName' | translate}}"  [modelData]="address.lastname" (modelDataOut)="address.lastname=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'Address' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="address.street" placeholder="{{'Street' | translate}}/{{'StreetNumber' | translate}}"  (modelDataOut)="address.street=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'Zip' | translate}}/{{'City' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="address.zip" placeholder="{{'Zip' | translate}}/{{'City' | translate}}"  (modelDataOut)="address.zip=$event"></edit-input> <edit-input [isEdit]="isEdit"  placeholder="Ort"  [modelData]="address.city" (modelDataOut)="address.city=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'Country' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" [modelData]="address.country" placeholder="{{'Country' | translate}}"  (modelDataOut)="address.country=$event"></edit-input></ion-col>
  </ion-row>
  <ion-row>
    <ion-col text-bold>{{'Birthday' | translate}}</ion-col>
    <ion-col><edit-input [isEdit]="isEdit" type="date" [modelData]="address.birthDate | checkDate | date:'dd.MM.yyyy'" (modelDataOut)="address.birthDate=$event"></edit-input></ion-col>
  </ion-row>
  <fieldset>
    <legend>{{'Comment' | translate}}</legend>
    <edit-input [isEdit]="isEdit" type="textarea" [modelData]="address.info" (modelDataOut)="address.info=$event"></edit-input>
  </fieldset>
</div>

